import {Component, computed, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalErrorComponent} from '../modal-error/modal-error.component';
import {ModalErrorService} from '../../../core/services/modal-error.service';

@Component({
  selector: 'modal-error-host',
  standalone: true,
  imports: [CommonModule, ModalErrorComponent],
  template: `
    <modal-error
      *ngIf="vm().show"
      [title]="vm().title"
      (close)="close()"
    >
      <p *ngFor="let msg of vm().messages">
        <strong *ngIf="msg.bold">{{ msg.text }}</strong>
        <span *ngIf="!msg.bold">{{ msg.text }}</span>
      </p>
    </modal-error>
  `,
})
export class ModalErrorHostComponent {
  private readonly modal = inject(ModalErrorService);

  readonly vm = computed(() => this.modal.state());

  close(): void {
    this.modal.close();
  }
}
